import React, { useEffect, useState } from "react";
import cx from "classnames";
import maskPhone from "helpers/handlePhoneMask";

type Props = {
  placeholder: string;
  value: string;
  type?: string;
  isHelp?: boolean;
  helpText?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const PhoneInput: React.FC<Props> = ({
  placeholder,
  helpText,
  type = "text",
  isHelp,
  className,
  value,
  onChange,
}): JSX.Element => {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setInputValue(maskPhone(value));
  }, [value]);

  return (
    <div className={cx("flex flex-col min-w-0", className)}>
      <div
        className={cx(
          "flex flex-row border-b border-bt-gray",
          isHelp ? "border-bt-red my-1" : "my-2"
        )}
      >
        <input
          className={cx(
            "w-full border-none mr-3 px-2 py-2 border-transparent focus:border-transparent focus:ring-0"
          )}
          type={type}
          placeholder={placeholder}
          value={inputValue}
          onChange={onChange}
          autoComplete="off"
        />
      </div>
      {isHelp && helpText && (
        <div className="flex flex-row">
          <span className="font-nunito mt-1 text-xs text-bt-red">
            {helpText}
          </span>
        </div>
      )}
    </div>
  );
};

export default PhoneInput;
